import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { FaArrowCircleUp } from 'react-icons/fa'

const ToTop = styled.div`
        display:block;
        opacity:1;
        visibility:visible;
        position:fixed;
        bottom:3vh;
        right:50%;
        transform:translateX(-50%);
        z-index:50;
        text-align:center;
        border-radius:50%;
        font-size:50px;
        transition:0.3s all;
        cursor: pointer;
        animation:tong 1s 20 ease-in-out;
        color:floralwhite;
        @media screen and (max-width:768px) {
            bottom:15px;
            right:5px;
            font-size:35px;
            animation:unset;
    }
    @keyframes tong {
        50%{
            bottom:20px;
        }
    }
`

function Footer() {
    const [state, setState] = useState(true)
    const toggleVisibility = () => {
        if (window.pageYOffset > 300) {
            setState(false);
        } else {
            setState(true);
        }
    }
    useEffect(() => {
        window.addEventListener("scroll", toggleVisibility);
        return () => {
            window.removeEventListener("scroll", toggleVisibility);
        };
    });
    document.addEventListener('scroll', (e) => { })

    const toTheTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }

    return (
        <ToTop style={state ? { visibility: 'hidden', opacity: '0' } : { visibility: 'visible', opacity: '1' }} onClick={toTheTop}><span role='img' aria-label='to the top'><FaArrowCircleUp /></span></ToTop>
    )
}

export default Footer